<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Letter List"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Letter Name</th>
                  <th>Ref No.</th>
                  <th>Issue Date</th>
                  <th>Effective Date</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td> {{ item.employee_name }}</td>
                  <td> {{ item.template_name }}</td>
                  <td> {{ item.reference_number }}</td>
                  <td> {{ item.issue_date }}</td>
                  <td> {{ item.effective_date }}</td>
                  <td>
                    <button class="btn btn-primary btn-sm me-1"
                            @click="goToEdit(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <button class="btn btn-secondary btn-sm me-1"
                            @click="goToPrint(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-print"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleCompany from "@/services/modules/company";
import letterPdf from '@/services/utils/pdf/letterPdf';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 10,
});
const { exportToPDF } = letterPdf();

const token = computed(() => localStorage.getItem('token'));

const {
  fetchLetterList,
  fetchSingleLetter
} = handleHrPayroll()
const { fetchCompanyInfo } = handleCompany();
let companyInfo = reactive({})
let letterData = ref({})
const onClickToGo = () => {
  getLetterData();
}

function onClickAddNewButton() {
  router.push({name: `letters-add`, params: route.params, query: route.query})
}

const goToPrint = async (item) => {
  let query = `?company_id=${route.params.companyId}`;

  await fetchSingleLetter(item.id, query).then((res) => {
    if (!res.status) {
      return
    }
    letterData.value = res.data;
  }).then(() => {
    exportToPDF(companyInfo, letterData.value)
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.letterId = item.id;

  router.push({
    name:  'letters-add',
    params: param,
    query: query
  })
}

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getLetterData();
}
const getLetterData = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchLetterList(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }

        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    Promise.all([
      getLetterData(),
      setCompanyInfo()
    ])
})
</script>
